import React from 'react'
import './BarBase.css'
import './Colors.css'

export enum BarType {
  Error = 'bar bar-error',
  Warning = 'bar bar-warning',
  Info = 'bar bar-info',
  Success = 'bar bar-success'
}

export type Props = {
  message: string
  type: BarType
  onClose?: () => void
}

export type BarProps = {
  message: string
  onClose?: () => void
}

function BarBase(props: Props) {
  const { message, type, onClose, ...rest } = props

  function getIcon() {
    switch (type) {
      case BarType.Info: {
        return 'fas fa-info-circle'
      }

      case BarType.Warning: {
        return 'fas fa-exclamation-triangle'
      }

      case BarType.Success: {
        return 'fas fa-check-circle'
      }

      case BarType.Error: {
        return 'fas fa-exclamation-circle'
      }
    }
  }

  const componentClass = onClose ? 'bar-with-close' : 'bar'

  return (
    <div className={`${componentClass} ${type as string}`} {...rest}>
      <div>
        <i className={getIcon()}></i>&nbsp;
      </div>
      <div>
        {message}
      </div>

      {onClose && (
        <div className="align-right">
          <i className="fas fa-times bar-close-button" onClick={onClose}></i>
        </div>
      )}
    </div>
  )
}

export default BarBase
